import React from 'react';
import {ResponsiveLine} from '@nivo/line';
import EmptyContent from '@components/empty-content/empty-content';
// import rawData from './data.json';

interface GrowthChartComponentProps<T extends {[key: string]: any}> {
  data: T[];
}

const GrowthChartComponent: React.FC<GrowthChartComponentProps<any>> = ({
  data
}) => {
  if (!data || data.length === 0) {
    return <EmptyContent isFilled title="No Data" />;
  }

  const allXValues = data.flatMap(series =>
    series.data.map((point: any) => parseFloat(point.x))
  );

  const hasZero = allXValues.includes(0);
  const minX = hasZero ? 0 : Math.min(...allXValues);

  return (
    <div style={{width: '100%', height: '500px'}}>
      <ResponsiveLine
        data={data}
        margin={{top: 50, right: 10, bottom: 115, left: 50}}
        xScale={{type: 'linear', min: minX}}
        yScale={{
          type: 'linear',
          min: 'auto',
          max: 'auto',
          stacked: false
        }}
        axisBottom={{
          legend: 'X Axis',
          legendOffset: 36,
          legendPosition: 'middle'
        }}
        axisLeft={{
          legend: 'Y Axis',
          legendOffset: -40,
          legendPosition: 'middle'
        }}
        colors={(d: any) => d.color}
        enablePoints={true}
        pointSize={4}
        pointBorderColor={(d: any) => d.color}
        pointLabelYOffset={-12}
        enableSlices="x"
        useMesh={true}
        sliceTooltip={({slice}: any) => {
          return (
            <div
              style={{
                background: 'white',
                border: '1px solid #ccc',
                padding: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                // maxHeight: '300px',
                overflowY: 'auto'
              }}>
              {slice.points.map((point: any) => {
                const series = data.find(d => d.id === point.serieId);
                return (
                  <div
                    key={point.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '10px',
                      fontSize: '13px',
                      fontFamily: 'sans-serif'
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                      <div
                        style={{
                          width: '12px',
                          height: '12px',
                          backgroundColor: point.serieColor,
                          borderRadius: '2px'
                        }}
                      />
                      <span>{series?.percentile || point.serieId}</span>
                    </div>
                    <strong>{point.data.yFormatted}</strong>
                  </div>
                );
              })}
            </div>
          );
        }}
      />
    </div>
  );
};

export default GrowthChartComponent;
